// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3M_6-","notes":"Notes_notes__m3LWP","note":"Notes_note__64ikp","markdown":"Notes_markdown__3PgQO"};